<template>
<!-- <div id="app"> -->
<v-app id="inspire" class="Kanit">
  <div>
    <Navbar />
  </div>
  <v-content v-if="url_redirect">
    <v-layout column align-center justify-center id="desktop" class="white--text hidden-sm-and-down"
      style="background-image: url('./static/image/coding3.jpg') !important;background-size: 100% 100% ; height: 100%; width: 100%; background-repeat: no-repeat;margin-top: 0vh; overflow-y: hidden;">
      <v-container grid-md text-xs-center>
        <v-layout row :style="layoutLogin" justify-center=true>
          <v-flex sm2 md2 lg2 xl2></v-flex>
          <v-flex sm8 md8 lg8 xl8 v-if="progress">
            <v-progress-circular :size="100" :width="7" indeterminate color="blue"></v-progress-circular>
          </v-flex>

          <v-flex sm8 md8 lg8 xl8 v-else-if="type=='first'">
            <v-layout row justify-center style="justify-content: center;">
              <v-flex sm8 md8 lg8 xl8>
                <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 33vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { OneChat Develop }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <p style="color: white;font-weight: bold;">กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน</p>
                    <v-btn class="btnloginwebOneid" @click="loginRedirect()">เข้าสู่ระบบด้วย OneID</v-btn>
                  <v-flex xs12 sm12 md12 xl12 lg12>
                    <span class="textor"> หรีอ </span>
                  </v-flex>
                    <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วยเบอร์โทรศัพท์</v-btn>
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm8 md8 lg8 xl8 v-else-if="type=='phone'">
            <v-layout row style="justify-content: center;">
              <v-flex sm8 md8 lg8 xl8>
                <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 33vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <v-text-field solo label="เบอร์โทรศัพท์" v-model="phone" class="CSChatThai" style="text-align:center; color: white !important; border-radius:50px !important;" @keyup.enter="otp()" mask="###-###-####" prepend-inner-icon="phone">
                    </v-text-field>
                    <v-layout justify-center>
                      <!-- <v-flex xs6 sm6 lg6 xl6> -->
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom:28px; width:88px;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      <!-- </v-flex> -->
                      <!-- <v-flex xs6 sm6 lg6 xl6> -->
                        <v-btn @click="otp()" :disabled="phone === ''" :loading="loading" color="#2562af" style="margin-bottom: 30px;   margin-top: 1vh !important; width:88px; border-radius:50px; color:white;">ขอ OTP</v-btn>
                      <!-- </v-flex> -->
                    </v-layout>
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm8 md8 lg8 xl8 v-else-if="type=='otp'">
            <v-layout row style="justify-content: center;">
              <v-flex sm6 md6 lg6 xl6>
                <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 33vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <p style="color: white;">เบอร์โทร: {{phone}}</p>
                    <p style="color: white;" v-if="Refcode">Refcode: {{Refcode}}</p>
                    <v-layout row justify-center align-center>
                      <v-flex sm8 md8 lg8 xl8>
                        <v-text-field solo label="otp" v-model="otpCode" class="CSChatThai" maxlength="6" style="text-align:center; color: grey !important;" @keyup.enter="loginWithotp()"></v-text-field>
                      </v-flex>
                      <v-flex sm4 md4 lg4 xl4>
                        <v-btn depressed class="btnloginwebOneid_white" style="width: 40%; margin-top: -24px !important;" :disabled="counting" @click="otp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                            <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                          </countdown>
                          <span v-if="!counting">ส่ง OTP </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <!-- <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom:28px;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      </v-flex> -->
                      <v-flex xs12 sm12 lg12 xl12>
                        <v-btn class="btnloginwebOneid" @click="loginWithotp()" :loading="isLoading" :disabled="otpCode.length != 6" style="margin-bottom: 30px; width:88px;">เข้าสู่ระบบ</v-btn>
                      </v-flex>
                    </v-layout>
                    <!-- <v-btn class="btnloginwebOneid" @click="loginWithotp()" :disabled="otpCode.length != 6" style="margin-bottom: 30px;width: 40%;">เข้าสู่ระบบ</v-btn> -->
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm2 md2 lg2 xl2></v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <!-- mobile -->

    <v-layout column align-center justify-center id="desktop" class="white--text hidden-md-and-up"
      style="background-image: url('./static/image/coding3.jpg') !important;background-size: 100% 100% ; height: 100%; width: 100%; background-repeat: no-repeat;margin-top: 0vh; overflow: hidden;">
      <v-container grid-md text-xs-center>
        <v-layout row :style="layoutLogin" justify-center=true>
          <v-flex sm2 md2 lg2 xl2></v-flex>
          <v-flex sm8 md8 lg8 xl8 v-if="progress">
            <v-progress-circular :size="100" :width="7" indeterminate color="blue"></v-progress-circular>
          </v-flex>

          <v-flex sm12 md12 lg12 xl12 v-else-if="type=='first'">
            <v-layout row justify-center align-center style="justify-content: center;">
              <v-flex sm12 md12 lg12 xl12>
                <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h3 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { OneChat Develop }</h3>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black; justify-content: center; align-items: center; display: d-flex;">
                  <v-flex xs12 sm12 md12 xl12 lg12>
                    <p style="color: white;font-weight: bold;">กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน</p>
                  </v-flex>
                  <v-flex xs12 sm12 md12  xl12 lg12>
                    <v-btn class="btnloginwebOneid" @click="loginRedirect()">เข้าสู่ระบบด้วย OneID</v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 md12  xl12 lg12>
                    <span class="textormobile"> หรีอ </span>
                  </v-flex>
                  <v-flex xs12 sm12 md12  xl12 lg12>
                    <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วยเบอร์โทรศัพท์</v-btn>
                  </v-flex>
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm12 md12 lg12 xl12 v-else-if="type=='phone'">
            <v-layout row style="justify-content: center;">
              <v-flex sm12 md12 lg12 xl12>
                <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <v-text-field solo label="เบอร์โทรศัพท์" v-model="phone" class="CSChatThai" style="text-align:center; color: white !important; border-radius:50px !important;" @keyup.enter="otp()" mask="###-###-####" prepend-inner-icon="phone">
                    </v-text-field>
                    <v-layout justify-center>
                      <!-- <v-flex xs6 sm6 lg6 xl6> -->
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom: 30px; width: 88px; height:36px !important;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      <!-- </v-flex> -->
                      <!-- <v-flex xs6 sm6 lg6 xl6> -->
                        <v-btn @click="otp()" :disabled="phone === ''" :loading="loading" color="#2562af" style="margin-bottom: 30px;width: 88px; height:36px;  margin-top:1vh; border-radius:50px; color:white;">ขอ OTP</v-btn>
                      <!-- </v-flex> -->
                    </v-layout>
                    <!-- <v-btn @click="otp()" :disabled="phone === ''" :loading="loading" color="#2562af" style="margin-bottom: 30px;width: 40%; border-radius:50px; color:white;">ขอ OTP</v-btn> -->
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm12 md12 lg12 xl12 v-else-if="type=='otp'">
            <v-layout row style="justify-content: center;">
              <v-flex sm12 md12 lg12 xl12>
                <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #000000b8;">
                  <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <p style="color: white;">เบอร์โทร: {{phone}}</p>
                    <p style="color: white;" v-if="Refcode">Refcode: {{Refcode}}</p>
                    <v-layout row justify-center align-center>
                      <v-flex sm8 md8 lg8 xl8>
                        <v-text-field solo label="otp" v-model="otpCode" class="CSChatThai" maxlength="6" style="text-align:center; color: grey !important;" @keyup.enter="loginWithotp()"></v-text-field>
                      </v-flex>
                      <v-flex sm4 md4 lg4 xl4>
                        <v-btn depressed class="btnloginwebOneid_white" style="width: 40%; margin-top: -24px !important;" :disabled="counting" @click="otp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                            <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                          </countdown>
                          <span v-if="!counting">ส่ง OTP </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <!-- <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom: 28px; width: 40% !important;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      </v-flex> -->
                      <v-flex xs12 sm12 lg12 xl12>
                        <v-btn class="btnloginwebOneid" @click="loginWithotp()" :loading="isLoading" :disabled="otpCode.length != 6" style="margin-bottom: 30px; width: 88px;">เข้าสู่ระบบ</v-btn>
                      </v-flex>
                    </v-layout>
                    <!-- <v-btn class="btnloginwebOneid" @click="loginWithotp()" :disabled="otpCode.length != 6" style="margin-bottom: 30px;width: 40%;">เข้าสู่ระบบ</v-btn> -->
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm2 md2 lg2 xl2></v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <!-- -------------------------------------------- -->
  </v-content>
  <v-content v-else>
    <v-layout column align-center justify-center id="desktop" class="white--text hidden-sm-and-down"
      style="background-image: url('./static/image/coding3.jpg') !important;background-size: 100% 100% ; height: 100%; width: 100%; background-repeat: no-repeat;margin-top: 0vh; overflow-y: hidden;">
      <v-container grid-md text-xs-center>
        <v-layout row :style="layoutLogin" justify-center=true>
          <v-flex sm2 md2 lg2 xl2></v-flex>
          <v-flex sm8 md8 lg8 xl8 v-if="progress">
            <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
          </v-flex>
          <v-flex sm8 md8 lg8 xl8 v-else>
            <v-layout row style="justify-content: center;">
              <v-flex sm6 md6 lg6 xl6>
                <v-card class="elevation-24" flat style="margin: 0px; width: 33vw;border-radius: 10px; background: #000000b8 ;">
                  <v-card-title primary-title style="width: 33vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <v-form v-model="valid">

                      <v-text-field solo label="ชื่อผู้ใช้งาน" v-model="username" class="CSChatThai" style="text-align:center; color: white !important;" @keyup.enter="login()" @keypress="isNumandaz($event)" prepend-inner-icon="person"></v-text-field>

                      <v-text-field solo label="รหัสผ่าน" v-model="password" class="CSChatThai" :type="showPassword ? 'text' : 'password'" style="text-align:center;" @keyup.enter="login()" @keypress="isnotthai($event)" prepend-inner-icon="lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"></v-text-field>

                      <div v-if="status == 'fail' " style="color: #f9a1a1;  width: 100%;">
                        <v-icon style="color: #f9a1a1;">info</v-icon> {{failmessage}}
                      </div>
                      <v-btn class="btnloginweb" @click="login()">เข้าสู่ระบบ</v-btn>
                      <div style="padding-bottom:5vh;padding-top:1vh;text-align: center;">
                        <p class="CSChatThai" style="text-align: right;"><b><span class="forgetpass" @click="open_link('https://one.th/type_forgot_password')">ลืมรหัสผ่าน?</span></b></p>
                      </div>
                    </v-form>
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm2 md2 lg2 xl2></v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout column align-center justify-center id="desktop" class="white--text hidden-md-and-up"
      style="background-image: url('./static/image/coding3.jpg') !important;background-size: 100% 100% ; height: 100%; width: 100%; background-repeat: no-repeat;margin-top: 0vh; overflow-y: hidden;">
      <v-container grid-md text-xs-center>
        <v-layout row :style="layoutLogin" justify-center=true>
          <v-flex sm2 md2 lg2 xl2></v-flex>
          <v-flex sm8 md8 lg8 xl8 v-if="progress">
            <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
          </v-flex>
          <v-flex sm8 md8 lg8 xl8 v-else>
            <v-layout row style="justify-content: center;">
              <v-flex sm6 md6 lg6 xl6>
                <v-card class="elevation-24" flat style="margin: 0px; width: 90vw;border-radius: 10px; background: #000000b8 ;">
                  <v-card-title primary-title style="width: 90vw;">
                    <v-layout row align-center justify-center>
                      <div class="headline Kanit">
                        <h4 style="font-weight:700; color:white; padding-top: 1vh;padding-bottom: 1vh;" class="centerDiv CSChatThai"> { ลงชื่อเข้าใช้งาน }</h4>
                      </div>
                    </v-layout>
                  </v-card-title>
                  <div style="padding:0px 15%; color: black;">
                    <v-form v-model="valid">

                      <v-text-field solo label="ชื่อผู้ใช้งาน" v-model="username" class="CSChatThai" style="text-align:center; color: white !important;" @keyup.enter="login()" @keypress="isNumandaz($event)" prepend-inner-icon="person"></v-text-field>

                      <v-text-field solo label="รหัสผ่าน" v-model="password" class="CSChatThai" :type="showPassword ? 'text' : 'password'" style="text-align:center;" @keyup.enter="login()" @keypress="isnotthai($event)" prepend-inner-icon="lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"></v-text-field>

                      <div v-if="status == 'fail' " style="color: #f9a1a1;  width: 100%;">
                        <v-icon style="color: #f9a1a1;">info</v-icon> {{failmessage}}
                      </div>
                      <v-btn class="btnloginweb" @click="login()">เข้าสู่ระบบ</v-btn>
                      <div style="padding-bottom:5vh;padding-top:1vh;text-align: center;">
                        <p class="CSChatThai" style="text-align: right;"><b><span class="forgetpass" @click="open_link('https://one.th/type_forgot_password')">ลืมรหัสผ่าน?</span></b></p>
                      </div>
                    </v-form>
                  </div>
                </v-card>
                <div style="text-align: right !important;">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm2 md2 lg2 xl2></v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-content>
</v-app>
</template>
<!-- <script src="https://unpkg.com/vue/dist/vue.js"></script> -->
<!-- <script src="https://unpkg.com/vuetify/dist/vuetify.js"></script> -->

<script>
import Navbar from '@/components/home/Navbarapi'
import Vue from 'vue'
import {
  Encode
} from '@/services'
// import VueCountdown from '@chenfengyuan/vue-countdown'
import {
  mapState
} from 'vuex'
// Vue.component(VueCountdown.name, VueCountdown)
import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);
// import $ from 'jquery'
// import VueSocketio from 'vue-socket.io'
export default {
  data() {
    return {
      //   valid: '',
      //   username: '',
      //   password: '',
      //   usernamemo: '',
      //   passwordmo: '',
      //   status: '',
      //   friend: '',
      //   status_login: '',
      //   layoutLogin: 'align-items: center; margin-top: 20vh;',
      //   layoutLoginmo: 'align-items: center; margin-top: 10vh;',
      //   cardLogin: 'height: auto; width: auto; justify-center; margin-top: 8vh; border-radius: 10px; background-color: #000000b8',
      //   cardLoginweb: 'margin: 0px; width: 33vw;border-radius: 10px; background:#000000b8; justify-content: center;',
      //   progress: false,
      //   progressmo: false,
      //   failmessage: 'Username or Password is incorrect.',
      //
      layoutLogin: 'align-items: center; margin-top: 20vh;',
      layoutLoginmo: 'align-items: center; margin-top: 10vh;',
      cardLogin: 'height: auto; width: auto; justify-center; margin-top: 8vh; border-radius: 10px; background-color: #000000b8',
      cardLoginweb: 'margin: 0px; width: 33vw;border-radius: 10px; background:#000000b8; justify-content: center;',
      //   type: 'first',
      type: 'phone',
      // type:'otp',
      usernameRules: [
        v => this.regular_username_mobile()
      ],
      passwordRules: [
        v => this.regular_pass_mobile()
      ],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน ไม่ถูกต้อง',
      webdev: process.env.WEBchatdev,
      showPassword: false,
      url_redirect: process.env.AuthenOneid,
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile',
      myname: 'myname'
    })
  },
  //   computed: {
  //     ...sync('*')
  //   },
  created() {
    this.status_login = localStorage.getItem('status_login')
    // console.log(this.status_login)
    if (this.status_login === 'T') {
      console.log(this.$vuetify.breakpoint)
      if (this.$vuetify.breakpoint.xs == true || this.$vuetify.breakpoint.sm == true) {
        this.$router.push('/mobile/develop/homepage')
      } else {
        this.$router.push('/develop/homepage')
      }
      // this.$router.push('/develop/homepage')
      // if (this.isMobile()) {
      //   this.$router.push('/mobile/develop/homepage')
      // } else {
      //   this.$router.push('/develop/homepage')
      // }
    }
    // else {
    //   window.open('https://one.th/oauth/authorize?client_id=2&response_type=code', '_parent')
    // }
    // }
  },
  mounted() {
    // console.log(localStorage.tologin)
  },
  // if(localStorage.tologin){
  //   this.type = 'phone'
  //   this.phone = localStorage.tologin
  // }
  methods: {
    backStep () {
      this.type = 'first'
      this.phone = ''
    },
    regular_username_mobile () {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '')
      this.username = this.username.toLowerCase()
    },
    regular_pass_mobile () {
      this.password = this.password.replace(/^[ก-๛]+/i, '')
    },
    isnotthai ($event) {
      // console.log($event)
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    randomString(num) {
      var text = ''
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (var i = 0; i < num; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text
    },
    reverse(s) {
      return s.split('').reverse().join('')
    },
    toPage(page) {
      this.$router.push(page)
    },
    regis() {
      // ga('send', 'event', 'Login Engagement', 'Click', 'Register')
      window.open('/register')
    },
    gohomepage() {
      // ga('send', 'event', 'homePage', 'clickToHomepage', 'tohomepage')
      this.$router.push('/')
    },
    regismo() {
      // ga('send', 'event', 'regisPageMo', 'clickToRegisMo', 'regis-usernameMo')
      // window.open('/Registermo', '_blank')
      window.open('/register', '_blank').focus()
    },
    gohomepagemo() {
      // ga('send', 'event', 'homePageMo', 'clickToHomepageMo', 'tohomepageMo')
      window.open('/homepage', '_blank')
    },
    isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false
      } else {
        return true
      }
    },
    //
    loginRedirect() {
      // this.progress = true
      console.log(this.url_redirect)
      window.open(this.url_redirect, '_parent')
    },
    otp() {
      this.loading = true
      this.$http.post(process.env.APImanage + '/otp_login_and_regis', {
        phone: this.phone,
        type: 'login'
      }).then((response) => {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'login') {
            this.loading = false
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = "otp"
          } else {
            this.loading = false
            this.phone = ''
            this.$swal(
              'ขออภัย!',
              'หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น',
              'error'
            )
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          this.loading = false
          this.$swal(
            'ขออภัย!',
            'ระบบขัดข้อง กรุณาลองใหม่ภายหลัง',
            'error'
          )
        } else if (response.data['message'] === 'too many requests.') {
          this.loading = false
          this.$swal(
            'ขออภัย!',
            'หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่',
            'error'
          )
        } else {
          this.loading = false
          this.$swal(
            response.data['status'],
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.type = 'first'
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    handleCountdownEnd() {
      this.OTP = ''
      this.counting = false
    },
    loginWithotp() {
      this.progress = true
      var source = {
        type_otp: this.type_otp,
        phone: this.phone,
        otp: this.otpCode,
        mobile_ref_id: this.mobile_ref_id
      }
      this.$http.post(process.env.APImanage + '/login_and_regis', source).then((response) => {
        this.status = response.data['status']
        // console.log(response.data)
        if (this.status === 'success') {
          var profile = response.data['account']['profile']
          // console.log(profile)

          localStorage.setItem('status_login', 'T')
          this.$cookies.set('Myusername', this.usernamemo)

          this.$store.dispatch('myProfile', profile['profilepicture'])
          localStorage.setItem('profilepicture', profile['profilepicture'])
          this.$store.dispatch('myName', profile['nickname'])
          localStorage.setItem('tokenservice', profile['tokenservice'])
          localStorage.setItem('name', profile['nickname'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('tokenuser', profile['tokenuser'])
          localStorage.setItem('usertype', profile['type'])
          if (response.data['account']['profile'] === '' || response.data['account']['profile'] === 'None') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          if (this.$vuetify.breakpoint.xs == true || this.$vuetify.breakpoint.sm == true) {
            this.$router.push('/mobile/develop/homepage')
          } else {
            this.$router.push('/develop/homepage')
          }
          this.$store.dispatch('tokenRoom', 'noneselect')
          this.$store.dispatch('changeRightTool', 'Friend')
          this.$cookies.set('tokenRoom', 'noneselect')
          localStorage.setItem('room', 'noneselect')
          this.$store.dispatch('changeBot', 'noneselect')
          this.progressmo = false
          //   localStorage.removeItem("tologin")
          //   localStorage.removeItem("tologin_keep2")
        } else {
          // this.$cookies.set('status_login', 'F')
          localStorage.setItem('status_login', 'F')
          this.progress = false
          this.$swal(
            'ขออภัย!',
            'กรอกรหัส OTP ไม่ถูกต้อง',
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    isNumandaz($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && (keyCode != 46) && (keyCode != 64)) { // 46 is dot
        $event.preventDefault();
      }
    },
    login() {
      var addyear = 10
      var newDate = new Date()
      newDate.setTime(newDate.getTime() + (addyear * 365 * 24 * 60 * 60 * 1000))
      var expiresInTime = "expires=" + newDate.toUTCString()

      if (this.username === '' || this.password === '') {
        console.log('hello')
        this.failmessage = 'กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน.'
      } else {
        this.progress = true
        var source = Encode.encode({
          'username': this.username,
          'password': this.password
        })
        this.$http.post(process.env.APImanage + '/loginuserwithbusiness', {
          source: source
        }).then((response) => {
          // console.log(response.data)
          this.status = response.data['status']
          if (this.status === 'success') {
            localStorage.setItem('status_login', 'T')
            this.$cookies.set('Myusername', this.username)
            this.$store.dispatch('myProfile', response.data['account']['profile']['profilepicture'])

            localStorage.setItem('profilepicture', response.data['account']['profile']['profilepicture'])
            this.$store.dispatch('myName', response.data['account']['profile']['nickname'])
            localStorage.setItem('tokenservice', response.data['account']['profile']['tokenservice'])
            localStorage.setItem('name', response.data['account']['profile']['nickname'])
            localStorage.setItem('phone', response.data['account']['profile']['phone'])
            localStorage.setItem('email', response.data['account']['profile']['email'])
            localStorage.setItem('status', response.data['account']['profile']['status'])
            localStorage.setItem('tokenuser', response.data['account']['profile']['tokenuser'])
            localStorage.setItem('usertype', response.data['account']['profile']['type'])
            if (response.data['account']['profile'] === '' || response.data['account']['profile'] === 'None') {
              localStorage.setItem('status_username', 'false')
            } else {
              localStorage.setItem('status_username', 'true')
            }
            this.$store.dispatch('tokenRoom', 'noneselect')
            this.$store.dispatch('changeRightTool', 'Friend')
            this.$cookies.set('tokenRoom', 'noneselect')
            localStorage.setItem('room', 'noneselect')
            this.$store.dispatch('changeBot', 'noneselect')
            this.progress = false
            if (this.$vuetify.breakpoint.xs == true || this.$vuetify.breakpoint.sm == true) {
              this.$router.push('/mobile/develop/homepage')
            } else {
              this.$router.push('/develop/homepage')
            }
            // if (this.isMobile()) {
            //   this.$router.push('/mobile/develop/homepage')
            // } else {
            //   this.$router.push('/develop/homepage')
            // }
          } else {
            // this.$cookies.set('status_login', 'F')
            localStorage.setItem('status_login', 'F')
            this.progress = false
            if (response.data['message'] === 'Wrong Username / Password') {
              this.failmessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง.'
            } else {
              this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
            }
          }
        }, (error) => {
          console.log(error)
          this.status = 'fail'
          this.progress = false
          this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
        })
      }
    },
    open_link(link) {
      window.open(link, '_blank')
    },
  },
  components: {
    Navbar
  }
}
</script>
<style scoped>
.btnloginBackStep {
  color: #044766 !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: rgb(255 255 255) !important;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
a:link {
  text-decoration: underline;
  color: white;
}

a:visited {
  color: white;
  text-decoration: underline;
}

a:hover {
  color: #00afff;
  text-decoration: underline;
}

a:active {
  text-decoration: underline;
}

.application .theme--light.card,
.theme--light .card {
  background: #0a0a0a80 !important;
  /*background: #0a0a0ad9 !important;*/
  /*background: rgba(0,0,0,0.6) !important;*/
}

/*.application .theme--light.card[data-v-9fcfedee], .theme--light .card[data-v-9fcfedee] {
  background: #0000008f !important;
}*/
html,
body {
  overflow: scroll;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.btnloginmobile {
  /*background-color: #f57c00 !important;
 color: black;
 width:20%;
 margin:0px;
 font-size: 12px;
 height: 6vh !important;*/
  width: 30%;
  font-size: 14px;
  color: white !important;
  /*width:40%;*/
  margin-top: 1vh !important;
  background-color: #00afff !important;
  /*height: 4vh !important;*/
  border-radius: 10px;
}

.btnregismobile {
  /*background-color:#FBFBFF !important;
  height: 4vh !important;
  border-radius: 10px;
  border: 2px solid #f57c00;*/
  width: 30%;
  font-size: 14px;
  color: #00afff !important;
  /*width:40%;*/
  margin-top: 1vh !important;
  background-color: #FBFBFF !important;
  /*height: 4vh !important; */
  border-radius: 10px;
  border: 2px solid #00afff;
}

.btnloginweb {
  color: white !important;
  width: 40%;
  margin-top: 1vh !important;
  background-color: #2562af !important;
  /*height: 4vh !important;*/
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.btnregisweb {
  color: #00afff !important;
  width: 40%;
  margin-top: 1vh !important;
  background-color: #FBFBFF !important;
  /*height: 4vh !important;*/
  border-radius: 10px;
  border: 2px solid #00afff;
  font-family: 'CS ChatThaiUI' !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

/*  */
.btnloginwebOneid {
  color: white !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: #2562af !important;
  /* background-color: #2562af !important; */
  /*border-radius: 10px;*/
  /* border: 2px solid white; */
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.btnloginwebOneid_white {
  color: #2562af !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid #2562af;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.textor {
  color: white;
}

.textor:after,
.textor:before {
  content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
  text-decoration: line-through;
  color: white;
}

.textormobile {
  color: white;
}

.textormobile:after,
.textormobile:before {
  content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
  text-decoration: line-through;
  color: white;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 50px;
  background: #fff;
}

.forgetpass {
  color: white !important;
  cursor: pointer !important;
}

.forgetpass:hover {
  color: white !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}

/* >>>.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #f5f5f5!important;
  color: grey !important;
} */

.btnloginwebOneid_whiteOtp {
  color: #2562af !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

/* [data-v-63ffbeea] .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #f5f5f5;
} */
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #f5f5f5 !important;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/new_login.vue